import { DropdownValue } from "./dropdown-value";

export class DropdownGroup {
  constructor(public label: string, public items: DropdownValue[]) {}
}
